import { render, staticRenderFns } from "./BusinessAnnualReturnsTask.vue?vue&type=template&id=f2dde244&scoped=true&"
import script from "./BusinessAnnualReturnsTask.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsTask.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsTask.vue?vue&type=style&index=0&id=f2dde244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dde244",
  null
  
)

export default component.exports